import React from "react";
import { Title } from '../../components/Text';
import { Table, TableContainer } from '../../components/Table';
import { Content } from "../../components/Layout";
import { Flex } from '../../components/Flex';
import { SearchBox } from "./SearchBox";
import { DropdownButton } from "../../components/Button";
import { DownIcon } from "../../icons/DownIcon";
import { PageContentPagination } from "./PageContentPagination";

const PageContent = ({
    tab={},
    reportTypes,
    makeReport,
    title,
    data,
    loading,
    onSearch,
    sortColumn,
    sortData,
    sortOrder,
    currentPage,
    totalRecords,
    setPageNumber
}) => {

    return(
        <Content gap={{ bottom: 28 }}>
            <Flex justify="space-between" gap={{ right: 16 }} >
                {typeof title === "string"
                    ? <Title h3 capitalize nowrap>{title}</Title>
                    : title
                }
                <Flex gap={{ right: 16 }} width="100%" justify="flex-end">
                    <SearchBox disabled={loading} onSearch={value => onSearch(value)} searchOptions={tab.searchOptions} />
                    {tab.header}
                </Flex>
            </Flex>
            <TableContainer>
                {tab.columns.length
                    ? <Table
                        columns={tab.columns}
                        dataSource={data}
                        loading={loading}
                        setSorting={sortData}
                        sortOrder={sortOrder}
                        sortColumn={sortColumn}
                    />
                    : null}
            </TableContainer>
            <Flex gap={{ right: 20}}>
                {(Array.isArray(tab.searchOptions) && tab.searchOptions.length) || tab.footer
                    ? <Flex align="center" gap={{ right: 18 }}>
                        {Array.isArray(tab.searchOptions) && tab.searchOptions.length
                            ? <DropdownButton items={reportTypes} onMenuClick={makeReport}>
                                Save Table as...
                                <DownIcon rotate={180} />
                            </DropdownButton>
                            : null}
                        {tab.footer}
                    </Flex>
                    : null}
                {tab.pagination && <PageContentPagination page={currentPage} total={totalRecords} changePage={setPageNumber}/>}
            </Flex>
        </Content>
    );
};

export { PageContent };